<template>
    <div class="text-center my-5">
        <div class="d-inline-block">
            <h1 class="mb-3">
                Dad Jokes
                <v-btn
                    x-small
                    icon
                    class="mb-4"
                    color="info"
                    @click="showTip = !showTip"
                >
                    <v-icon>mdi-information-outline</v-icon>
                </v-btn>
            </h1>
            <transition name="fade">
                <v-alert
                    v-if="showTip"
                    border="left"
                    color="info"
                    icon="mdi-information-outline"
                    elevation="1"
                    align="left"
                    close-text="Close this information box"
                    colored-border
                    dense
                >
                    <div>Dad Jokes are fetched from <a href="https://dadjokes.io/documentation/endpoints/random-jokes" target="_blank">DadJokes.io</a> API Endpoint</div>
                    <div class="text-right mt-3">
                        <v-btn
                            x-small
                            color="grey lighten-2"
                            elevation="0"
                            @click="showTip = false"
                        >
                            Close
                        </v-btn>
                    </div>
                </v-alert>
            </transition>
        </div>
        <transition name="fade" mode="out-in">
            <div v-if="!joke" key="isLoading" class="mt-10">Fetching joke...</div>
            <div v-else :key="joke._id" class="mt-7">
                <QuoteBubble
                    :selected-quote="joke.setup"
                    :quote-author="joke.punchline"
                />
                <div class="mb-3">
                    <div class="text-h5">🤣 🤣 🤣</div>
                </div>
                <div class="mt-6">
                    <v-btn @click="fetchJoke">
                        New Joke
                        <v-icon right>mdi-refresh</v-icon>
                    </v-btn>
                </div>
                <div class="mt-6" style="opacity:.35;"><small>Joke ID: {{ joke._id }}</small></div>
            </div>
        </transition>
    </div>
</template>

<script>
    import QuoteBubble from '../components/QuoteBubble';
    export default {
        components: {QuoteBubble},
        data() {
            return {
                showTip: false,
                joke: undefined,
            };
        },

        created() {
            this.fetchJoke();
        },

        computed: {
            imgData() {
                return this.joke ? this.joke.image : '';
            },
        },

        methods: {
            async fetchJoke() {
                const options = {
                    method: 'GET',
                    headers: {
                        'X-RapidAPI-Key': process.env.VUE_APP_DAD_JOKES_API_KEY,
                        'X-RapidAPI-Host': 'dad-jokes.p.rapidapi.com'
                    }
                };

                // https://www.dadjokes.io/documentation/getting-started
                // await fetch('https://dad-jokes.p.rapidapi.com/random/joke/png', options)
                await fetch('https://dad-jokes.p.rapidapi.com/random/joke', options)
                    .then(response => response.json())
                    .then(data => data.success ? this.joke = data.body[0] : console.error(data.success + ': Error fetching joke'))
                    .catch(err => console.error(err));
            },
        },
    };
</script>
